import { useCallback, useState } from "react";

export interface OpenState {
  open: boolean;
  /** Toggle between open and closed. Stable across renders. */
  toggle: () => void;
  /** Set to open. Stable across renders. */
  setOpen: () => void;
  /** Set to closed. Stable across renders. */
  setClose: () => void;
}

/** Manages a boolean open/closed state with stable, memoized callbacks. */
export function useOpenState(initial = false): OpenState {
  const [open, setOpenState] = useState(initial);
  const toggle = useCallback(() => setOpenState((v) => !v), []);
  const setOpen = useCallback(() => setOpenState(true), []);
  const setClose = useCallback(() => setOpenState(false), []);
  return { open, toggle, setOpen, setClose };
}
